import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { EmbeddedHomePage } from './HomePage';
import { EmbeddedResultsPage } from './ResultsPage';
export let EmbeddedGatePath = /*#__PURE__*/function (EmbeddedGatePath) {
  EmbeddedGatePath["EMBEDDED_GATE_HOME"] = "/";
  EmbeddedGatePath["EMBEDDED_GATE_RESULTS"] = "/results";
  return EmbeddedGatePath;
}({});
export const EmbeddedGatePages = _ref => {
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer,
    deviceType = _ref.deviceType,
    onSearchSubmit = _ref.onSearchSubmit;
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, {
    overrides: {
      getPurchasePermissions: {
        hasPermission: true
      }
    }
  }, /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: EmbeddedGatePath.EMBEDDED_GATE_RESULTS,
    render: () => /*#__PURE__*/React.createElement(EmbeddedResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer,
      deviceType: deviceType,
      onSearchSubmit: onSearchSubmit
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: EmbeddedGatePath.EMBEDDED_GATE_HOME,
    render: () => /*#__PURE__*/React.createElement(EmbeddedHomePage, {
      handlers: handlers,
      externalViewer: externalViewer,
      onSearchSubmit: onSearchSubmit
    })
  }))));
};
//# sourceMappingURL=EmbeddedGatePages.js.map